import { render } from "./incrementDecrementButton.vue?vue&type=template&id=561b0fdc"
import script from "./incrementDecrementButton.vue?vue&type=script&lang=js"
export * from "./incrementDecrementButton.vue?vue&type=script&lang=js"
script.render = render

export default script